/**
 * ActivityTable CSS Styles
 *
 * CSS-in-JS styles injected once on first component instantiation.
 * Scoped via .sm-activity- prefix.
 */
let stylesInjected = false;
const STYLES = `
.sm-activity-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 12px;
}

.sm-activity-days {
  display: flex;
  gap: 4px;
  background: #f3f4f6;
  border-radius: 8px;
  padding: 3px;
}

.sm-activity-day-btn {
  border: none;
  background: transparent;
  padding: 5px 10px;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
}

.sm-activity-day-btn.active {
  background: #dcfce7;
  color: #166534;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(0,0,0,0.08);
}

.sm-activity-types {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.sm-activity-type-chip {
  border: 1px solid #e5e7eb;
  background: #fff;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.75rem;
  color: #6b7280;
  cursor: pointer;
  white-space: nowrap;
}

.sm-activity-type-chip.active {
  background: #dcfce7;
  border-color: #86efac;
  color: #166534;
  font-weight: 600;
}

.sm-activity-table-wrap {
  overflow-x: auto;
}

.sm-activity-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.sm-activity-table th {
  text-align: left;
  padding: 8px 10px;
  border-bottom: 2px solid #e5e7eb;
  color: #6b7280;
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  white-space: nowrap;
}

.sm-activity-table th.sortable {
  cursor: pointer;
  user-select: none;
}

.sm-activity-table th.sortable:hover {
  color: #1f2937;
}

.sm-activity-table th.numeric,
.sm-activity-table td.numeric {
  text-align: right;
}

.sm-activity-table td {
  padding: 9px 10px;
  border-bottom: 1px solid #f3f4f6;
  vertical-align: top;
}

.sm-activity-date {
  white-space: nowrap;
  color: #6b7280;
}

.sm-activity-type-badge {
  white-space: nowrap;
  font-weight: 500;
}

.sm-activity-address {
  color: #1f2937;
  text-decoration: none;
}

.sm-activity-address:hover {
  text-decoration: underline;
}

.sm-activity-address-static {
  color: #1f2937;
}

/* Opt-in Cart toggle (agent app's Market Activity page only - see
   ActivityTableOptions.showAgentPickButton). Same Agent Pick color/
   shape convention as PropertyModal's own .sm-modal-agent-pick
   (packages/ui-components/src/PropertyModal/styles.ts), scaled down to
   sit inline in a table cell rather than a modal's action-button row. */
.sm-activity-agent-pick {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  margin-left: 6px;
  border: none;
  border-radius: 6px;
  background: #ffedd5;
  color: #ea580c;
  cursor: pointer;
  vertical-align: middle;
  flex-shrink: 0;
}

.sm-activity-agent-pick svg {
  width: 13px;
  height: 13px;
}

.sm-activity-agent-pick:hover {
  background: #fed7aa;
  color: #c2410c;
}

.sm-activity-agent-pick.active {
  background: #f97316;
  color: #ffffff;
}

.sm-activity-agent-pick.active:hover {
  background: #ea580c;
  color: #ffffff;
}

.sm-activity-price-sold-detail {
  font-size: 0.75rem;
  font-weight: 500;
  margin-top: 2px;
  color: #9ca3af;
}

.sm-activity-price-delta {
  font-size: 0.75rem;
  font-weight: 500;
  margin-top: 2px;
}

.sm-activity-price-delta.down {
  color: #16a34a;
}

.sm-activity-price-delta.up {
  color: #dc2626;
}

.sm-activity-empty {
  padding: 32px 16px;
  text-align: center;
  color: #6b7280;
}

.sm-activity-spinner {
  width: 24px;
  height: 24px;
  border: 3px solid #e5e7eb;
  border-top-color: #6366f1;
  border-radius: 50%;
  margin: 0 auto 10px;
  animation: sm-activity-spin 0.8s linear infinite;
}

@keyframes sm-activity-spin {
  to { transform: rotate(360deg); }
}

.sm-activity-more-note {
  margin-top: 10px;
  font-size: 0.75rem;
  color: #9ca3af;
  text-align: center;
}

@media (max-width: 640px) {
  .sm-activity-controls {
    flex-direction: column;
    align-items: stretch;
  }

  .sm-activity-types {
    justify-content: flex-start;
  }
}
`;
export function injectStyles() {
    if (stylesInjected)
        return;
    const styleEl = document.createElement('style');
    styleEl.id = 'sm-activity-table-styles';
    styleEl.textContent = STYLES;
    document.head.appendChild(styleEl);
    stylesInjected = true;
}
//# sourceMappingURL=styles.js.map